import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ApiClient from "../../methods/api/apiClient";
import "./style.scss";
import loader from "../../methods/loader";
import userTableModel from "../../models/table.model";
import Html from "./Html";
import { userType } from "../../models/type.model";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import environment from "../../environment";
import { toast } from "react-toastify";
import methodModel from "../../methods/methods";
import addressModel from "../../models/address.model";
// import RequestToken from "../../firebase/configuration";

const Bids2 = (p) => {
  const user = useSelector((state) => state.user);
  const [DataLength, setDataLength] = useState(0);
  const [ShowDeleteModal, setShowAcceptModal] = useState("none");
  const [Min_rate, setMin_rate] = useState("0");
  const [Max_rate, setMax_rate] = useState("5000");
  const [ShowActiveModal, setShowActiveModal] = useState("none");
  const { role } = useParams();
  const [ShowAwardModal, setshowAwardModal] = useState("none");
  const searchState = useSelector((state) => state.search);
  const [tabs, setTabs] = useState("Active");
  let localData = {
    page: 1,
    count: 10,
    search: "",
    role: role || "",
    isDeleted: false,
    sorder: "",
    // min_price: Min_rate,
    // max_price: Max_rate,
  }
  const [filters, setFilter] = useState(localStorage.getItem('bidsFilter') ? JSON.parse(localStorage.getItem('bidsFilter')) : localData);

  const [data, setData] = useState([]);
  const [tab, setTab] = useState("list");
  const [total, setTotal] = useState(0);
  const [ShowRejectModal, setShowRejectModal] = useState("none");
  const [loaging, setLoader] = useState(true);
  const [tableCols, setTableCols] = useState([]);
  const [form, setform] = useState(userType);
  const [roles, setRoles] = useState([]);
  const [loaderr, setLoaderr] = useState(false)
  const history = useHistory();
  const BidStatus = localStorage.getItem("BidStatus");
  const ShipmentStatus = localStorage.getItem("ShipmentStatus");
  const StartDate = methodModel.getPrams("startDate")
  const EndDate = methodModel.getPrams("endDate")
  useEffect(() => {
    // getRoles()
    if (BidStatus) {
      // setFilter({ ...filters, status: BidStatus });
      setTabs(BidStatus);

      setTimeout(() => {
        ChangeStatus(BidStatus);
      }, 1000);
    }
  }, [BidStatus]);
  const url = window.location.pathname;
  const CheckParamsPath = () => {
    switch (url) {
      case "/loads":
        setTabs("");
        return { key: "Loads", status: "" };
        break;
      case "/delivered-bids":
        setTabs("delivered");
        return { key: "Delivered Bids", status: "delivered" };
        break;
      case "/accepted-bids":
        setTabs("accepted");

        return { key: "Delivered Bids", status: "accepted" };
        break;
      case "/pending-bids":
        setTabs("pending");

        return { key: "Pending Bids", status: "pending" };
        break;
      case "/rejected-bids":
        setTabs("rejected");

        return { key: "Rejected Bids", status: "rejected" };
        break;
      case "/awarded-bids":
        setTabs("awarded");
        return { key: "Awarded Bids", status: "awarded" };
        break;
      case "/intransit-bids":
        setTabs("in_transit");
        return { key: "in Transit Bids", status: "in_transit" };
        break;
      default:
        setTabs("Active");
        return { key: "All Bids", status: "" };
    }
  };
  useEffect(() => {
    if (ShipmentStatus) {
      // setFilter({ ...filters, shipment_status: ShipmentStatus });
      setTabs(ShipmentStatus);
      setTimeout(() => {
        ChangeShipmentStatus(ShipmentStatus);
      }, 1000);
    }
  }, [ShipmentStatus]);

  useEffect(() => {
    localStorage.removeItem("BidStatus");
    localStorage.removeItem("ShipmentStatus");
  }, [filters, tabs]);

  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter(prev => ({ ...prev, search: searchState.data, role }));



      getData({ search: searchState.data, role, page: 1 });

    }
  }, [searchState, role, url]);

  const uTableCols = () => {
    let exp = [];
    if (tableCols) exp = tableCols;
    let value = [];
    userTableModel.list.map((itm) => {
      if (itm != exp.find((it) => it.key == itm.key)) {
        value.push(itm);
      }
    });
    return value;
  };

  const addCol = (itm) => {
    setTableCols([...tableCols, itm]);
  };

  const addressResult = async (e) => {
    let address = {};
    if (e.place) {
      address = await addressModel.getAddress(e.place);
    }

    setFilter({
      ...filters,
      origin_location_street: e.value,
      origin_location_country: address.country || "",
      origin_location_city: address.city || "",
      origin_location_state: address.state || "",
      origin_location_postal_code: address.zipcode || "",
      // lat: `${address.lat}` || '',
      // lng: `${address.lng}` || ''
    });
    getData({ origin_location_city: address.city });

  };
  const removeCol = (index) => {
    let exp = tableCols;
    exp.splice(index, 1);
    setTableCols([...exp]);
  };

  const getData = (p = {}) => {
    setLoader(true);
    setLoaderr(true)
    let filter = {
      ...filters,
      startDate: StartDate,
      endDate: EndDate,
      ...p
    };

    if (CheckParamsPath()?.status == "awarded") {
      filter = { ...filter, status: "awarded", shipment_status: "" };
    } else if (CheckParamsPath()?.status == "delivered") {
      filter = { ...filter, shipment_status: "delivered", status: "" };
    } else {
      filter = {
        ...filter,
        status: CheckParamsPath()?.status,
        shipment_status: "",
      };
      // request_status: CheckParamsPath(),}
    }
    let url = "bids";

    if (filter.status == 'in_transit') {
      filter.status = ''
      filter.shipment_status = 'in_transit'
    }

    localStorage.setItem('bidsFilter', JSON.stringify(filter))
    ApiClient.get(url, filter).then((res) => {
      if (res.success) {
        const data = res?.data?.data;
        const newarray = [];
        if (user.role && user.role.id == "64e5d268c27faa1d3ef35503") {
          data.filter((item) => {
            if (item.role && item.role._id != "64e5d268c27faa1d3ef35503") {
              newarray.push(item);
            }
          });
          setData(newarray);
          setDataLength(newarray.length);

          if (newarray.length == 0) {
            // setFilter({...filters,page:1})
            // getData({page:1})
          }
        } else {
          setData(data);
          setDataLength(data.length);
          if (data.length == 0) {
            // setFilter({...filters,page:1})
            // getData({page:1})
          }
        }
        setTotal(res?.data?.total);
        setLoaderr(false)
      }
      setLoader(false);
    });
  };
  const ChangeFilter = (e) => {
    setFilter(e);
    getData(e);
  };

  const clear = () => {
    setFilter({ ...filters, search: "" });
    getData({ search: "" });
  };

  const getRoles = () => {
    ApiClient.get("roles/listing", { status: "active" }).then((res) => {
      if (res.success) {
        if (user.role && user.role.id == "64e5d268c27faa1d3ef35503") {
          const data = res.data;
          const newarray = [];
          data.map((item, index) => {
            if (item.id != "64e5d268c27faa1d3ef35503") {
              newarray.push(item);
            }
          });
          setRoles(newarray);
        } else {
          setRoles(res.data);
        }
      }
    });
  };

  const completeBid = (id) => {
    // if (window.confirm("Do you want to delete this")) {
    loader(true);
    ApiClient.put(`bid?id=${id}&status=accepted`).then((res) => {
      if (res.success) {
        // toast.success(res.message);
        setShowAcceptModal("none");
        document.getElementById("AcceptBidCloseBtn").click();
        // setshowAwardModal("flex");
        // Swal.fire({
        //   title: "Do you want to award this bid?",
        //   showDenyButton: true,
        //   // showCancelButton: true,
        //   confirmButtonText: "Yes",
        //   denyButtonText: `No`,
        // }).then((result) => {
        //   /* Read more about isConfirmed, isDenied below */
        //   if (result.isConfirmed) {
        //     ApiClient.put(`bid?id=${id}&status=awarded`).then((res) => {
        //       if (res.success) {
        //         toast.success("Bid awarded successfully");
        //       }
        //     });
        //     // Swal.fire("Saved!", "", "success");
        //     if (DataLength == 0) {
        //       setFilter({ ...filters, search: "", page: 1 });
        //       getData({ search: "", page: 1 });
        //     } else {
        //       clear();
        //     }
        //   } else if (result.isDenied) {
        //     if (DataLength == 0) {
        //       setFilter({ ...filters, search: "", page: 1 });
        //       getData({ search: "", page: 1 });
        //     } else {
        //       clear();
        //     }
        //   }
        // });

        setFilter({ ...filters, search: "", page: 1 });
        getData({ search: "", page: 1 });
      }
      loader(false);
    });
    // }
  };

  const AwardBid = (id) => {
    loader(true);
    ApiClient.put(`bid?id=${id}&status=awarded`).then((res) => {
      if (res.success) {
        // toast.success("Bid awarded successfully");
        setshowAwardModal("none");
        loader(false);
        getData({ search: "", page: 1 });
      }
      loader(false);
    });
  };

  const rejectBid = (id, BoardFilter = filters?.board_id) => {
    // if (window.confirm("Do you want to delete this")) {
    loader(true);
    ApiClient.put(`bid?id=${id}&status=rejected`).then((res) => {
      if (res.success) {
        // toast.success(res.message);
        setShowRejectModal("none");
        if (DataLength == 0) {
          setFilter(prev => ({ ...prev, search: "", page: 1, board_id: BoardFilter || prev?.board_id }));
          getData({ search: "", page: 1, board_id: BoardFilter || filters?.board_id });
        } else {
          clear();
        }
      }
      loader(false);
    });
    // }
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const modalClosed = () => {
    setFilter({ ...filters, page: 1 });
    getData({ page: 1 });
  };

  const modalResult = (e) => {
    // console.log("modalResult", e);
    modalClosed();
  };

  const openModal = (itm) => {
    let extra = new Date().getTime();
    setform({ ...itm, extra, role });
    document.getElementById("openuserModal").click();
  };

  const ChangeRole = (e) => {
    setFilter({ ...filters, role: e, page: 1 });
    getData({ role: e, page: 1 });
  };
  const ChangeStatus = (e) => {
    setFilter({ ...filters, status: e, page: 1, shipment_status: "" });
    getData({ status: e, page: 1, shipment_status: "" });
  };

  const ChangeShipmentStatus = (key) => {
    setFilter({ ...filters, shipment_status: key, status: "" });
    getData({ shipment_status: key, page: 1, status: "" });
  };
  const ChangeDocumentStatus = (e) => {
    setFilter({ ...filters, isVerifiedDocument: e, page: 1 });
    getData({ isVerifiedDocument: e, page: 1 });
  };
  const exportCsv = () => {
    loader(true);
    ApiClient.get("user/csv").then((res) => {
      if (res.success) {
        let url = res.path;
        let downloadAnchor = document.getElementById("downloadJS");
        downloadAnchor.href = url;
        downloadAnchor.click();
      }
      loader(false);
    });
  };

  const colClick = (col, itm) => {
    if (col.key == "healthClinicId") {
    }
  };

  const statusChange = (itm) => {
    let modal = "loadmanagement";
    let status = "active";
    if (itm.status == "active") status = "deactive";

    // if(window.confirm(`Do you want to ${status=='active'?'Activate':'Deactivate'} this user`)){
    loader(true);
    ApiClient.put(
      `change/status?model=loadmanagement&id=${itm?.id}&status=${status}`
    ).then((res) => {
      if (res.success) {
        getData();
        // toast.success(
        //   ` Bid ${status == "active" ? "Enabled" : "Disabled"} Successfully`
        // );
        setShowActiveModal("none");
      }
      loader(false);
    });
    // }
  };

  const blockunblock = (itm) => {
    if (
      window.confirm(
        `Do you want to ${!itm.isBlock ? "Block" : "Un-block"} this user`
      )
    ) {
      loader(true);
      ApiClient.put(`edit-profile`, {
        id: itm.id,
        isBlock: itm.isBlock ? false : true,
      }).then((res) => {
        if (res.success) {
          getData();
        }
        loader(false);
      });
    }
  };

  const deleteLoad = (id) => {
    if (window.confirm("Do you want to delete this ?")) {
      loader(true);
      ApiClient.delete(`delete?model=loadmanagement&id=${id}`).then((res) => {
        if (res.success) {
          // toast.success(res?.message);
          getData();
        }
        loader(false);
      });
    }
  };
  const view = (id) => {
    history.push("bids/view/" + id);
  };

  const edit = (id) => {
    let url = `/loads/edit/${id}`;
    if (role) url = `/users/${role}/edit/${id}`;
    history.push(url);
  };

  const add = () => {
    let url = `/loads/add`;
    if (role) url = `/users/${role}/add`;
    history.push(url);
  };

  const tabChange = (tab) => {
    setTab(tab);
  };

  const exportfun = async () => {
    const token = await localStorage.getItem("token");
    const req = await axios({
      method: "get",
      url: `${environment.api}api/export/user`,
      responseType: "blob",
      body: { token: token },
    });
    var blob = new Blob([req.data], {
      type: req.headers["content-type"],
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `Users.xlsx`;
    link.click();
  };

  const reset = () => {
    let filter = {
      status: "",
      role: "",
      page: 1,
    };
    setFilter({ ...filters, ...filter });
    getData({ ...filter });
    // dispatch(search_success(''))
  };

  const isAllow = (key = "") => {
    return true;
    let permissions = user.role?.permissions;
    let value = permissions?.[key];
    if (user?.role?.id == environment.adminRoleId) value = true;

    return value;
  };
  const filter = (p = {}) => {
    setFilter({ ...filters, ...p });
    getData({ ...p, page: filters?.page });
  };
  const sorting = (key, i) => {
    // getData({sortBy})
    filter({ sortBy: key, sorder: i });
  };
  return (
    <>
      <Html
        user={user}
        colClick={colClick}
        exportfun={exportfun}
        isAllow={isAllow}
        tabChange={tabChange}
        tab={tab}
        reset={reset}
        add={add}
        roles={roles}
        view={view}
        edit={edit}
        AwardBid={AwardBid}
        role={role}
        ChangeRole={ChangeRole}
        ChangeStatus={ChangeStatus}
        openModal={openModal}
        pageChange={pageChange}
        addCol={addCol}
        exportCsv={exportCsv}
        uTableCols={uTableCols}
        removeCol={removeCol}
        filters={filters}
        ChangeDocumentStatus={ChangeDocumentStatus}
        setShowActiveModal={setShowActiveModal}
        ShowActiveModal={ShowActiveModal}
        tableCols={tableCols}
        loaging={loaging}
        data={data}
        ShowDeleteModal={ShowDeleteModal}
        setShowAcceptModal={setShowAcceptModal}
        total={total}
        statusChange={statusChange}
        blockunblock={blockunblock}
        setFilter={setFilter}
        sorting={sorting}
        completeBid={completeBid}
        addressResult={addressResult}
        getData={getData}
        ChangeFilter={ChangeFilter}
        deleteLoad={deleteLoad}
        rejectBid={rejectBid}
        ShowRejectModal={ShowRejectModal}
        ChangeShipmentStatus={ChangeShipmentStatus}
        setShowRejectModal={setShowRejectModal}
        Min_rate={Min_rate}
        setMax_rate={setMax_rate}
        Max_rate={Max_rate}
        tabs={tabs}
        setTabs={setTabs}
        setshowAwardModal={setshowAwardModal}
        ShowAwardModal={ShowAwardModal}
        setMin_rate={setMin_rate}
        CheckParamsPath={CheckParamsPath}
        loaderr={loaderr}
      />
    </>
  );
};

export default Bids2;
